function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#FF7664"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.1494 23.3916H18.9043L18.6572 12.3594H21.4072L21.1494 23.3916ZM18.582 26.7646C18.582 26.3564 18.7145 26.0199 18.9795 25.7549C19.2445 25.4827 19.6061 25.3467 20.0645 25.3467C20.5228 25.3467 20.8844 25.4827 21.1494 25.7549C21.4144 26.0199 21.5469 26.3564 21.5469 26.7646C21.5469 27.1585 21.418 27.488 21.1602 27.7529C20.9023 28.0179 20.5371 28.1504 20.0645 28.1504C19.5918 28.1504 19.2266 28.0179 18.9688 27.7529C18.7109 27.488 18.582 27.1585 18.582 26.7646Z",
  fill: "white"
});

function SvgEsrRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsrRed);
export default __webpack_public_path__ + "static/media/esr-red.d9c39cdd.svg";
export { ForwardRef as ReactComponent };